<script>
    export default {
        props: {
            open: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                loaded: false,
                availableReportTypes: [
                    // TODO: add NPR report when available (https://linear.app/nordhealth/issue/AGI-5699/add-sub-nav-menu)
                    // {
                    //     name: 'NPR',
                    //     type: 'npr',
                    //     icon: 'nord-icon-npr',
                    //     route: '/app/reports/npr',
                    // },
                    {
                        name: 'ASA 4313',
                        type: 'asa4313',
                        icon: 'nord-icon-asa4313',
                        route: '/app/reports/asa-4313',
                    }
                ],
            }
        },
    }
</script>

<template>
    <template v-if="open">
        <nord-nav-group class="n-margin-is-l n-margin-be-s">
            <template v-for="report in availableReportTypes" :key="report.type">
                <nord-nav-item :href="report.route">
                    <nord-stack direction="horizontal" align-items="center">
                        <nord-stack gap="none" class="clients-item-info">
                            <span class="name hovermenu-span">{{ report.name }}</span>
                        </nord-stack>
                    </nord-stack>
                </nord-nav-item>
            </template>
        </nord-nav-group>
    </template>
</template>